<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
             <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/">Início</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Quadro societário / {{ client.name }}</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="tab-content">
                    <div class="tab-pane active" role="tabpanel" id="info">
                        <div class="card shadow mb-4">
                            <!-- Card Header - Dropdown -->
                            <div class="card-body">
                                <div
                                    class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                                    <h6 class="m-0 font-weight-bold text-primary">Sócios</h6>
                                </div>
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12">
                                        <div class="table-responsive">
                                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Nome</th>
                                                        <th class="text-center">Documento</th>
                                                        <th class="text-center">E-mail</th>
                                                        <th class="text-center">Telefone</th>
                                                        <th class="text-center">Sócio Administrador</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(client_managing_partner, index) in client_managing_partner_saved"
                                                        :key="client_managing_partner.id">
                                                        <td>{{ index + 1 }}</td>
                                                        <td>{{ client_managing_partner.name }} </td>
                                                        <td class="text-center">{{
                                                            client_managing_partner.document_formatted }}</td>
                                                        <td class="text-center">{{ client_managing_partner.email != '' ?
                                                            client_managing_partner.email:'-' }}
                                                        </td>
                                                        <td class="text-center">{{
                                                            client_managing_partner.phone_formatted }}</td>
                                                        <td class="text-center">Sim</td>
                                                    </tr>
                                                    <tr v-for="(client_corporate_structure, index) in client_corporate_structure_saved"
                                                        :key="client_corporate_structure.id">
                                                        <td>{{ index + 1 }}</td>
                                                        <td>{{ client_corporate_structure.name }} </td>
                                                        <td class="text-center">{{
                                                            client_corporate_structure.document_formatted }}</td>
                                                        <td class="text-center">{{ client_corporate_structure.email }}
                                                        </td>
                                                        <td class="text-center">{{
                                                            client_corporate_structure.phone_formatted }}</td>
                                                        <td class="text-center">Não</td>
                                                    </tr>
                                                    <tr
                                                        v-show="client_managing_partner_saved.length <= 0 && client_corporate_structure_saved.length <= 0">
                                                        <td colspan="7" class="text-center">Nenhum registro de
                                                            associados encontrado
                                                        </td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import { capitalize } from '@/util';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

export default {
    components: { Loading },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            client: {name:''},
            client_corporate_structure_saved: {},
            client_managing_partner_saved: [],
            client_id: '',
            client_corporate_structure: {
                id: '',
                document: '',
                name: '',
                email: '',
                phone: '',
                id_corporate_structure_client: ''
            },
            enable_error_list: false,
            errors: [],

        }
    },

    computed: {
        isDisabled: function () {
            return this.client_corporate_structure.name != '' && this.client_corporate_structure.document != '' && this.client_corporate_structure.email != '' && this.client_corporate_structure.phone != '';
        }
    },
    beforeMount() {
        const id =  localStorage.getItem('client_id');
        this.client.id = id;
    },
    mounted() {
        this.isLoading = false;
        this.getManagingPartner();
        this.getCorporateStructureClient();

    },
    methods: {
        onCancel() { },

        setCapitalize(text) {
            return capitalize(text);
        },

        formatReal(value) {
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(value);
        },

        getManagingPartner() {
            api.get('/client-user/' + this.client.id + "/managingPartner")
                .then((response) => {
                    this.isLoading = false;
                    this.client.name = response.data.client.name;
                    if (response.data.managing_partner_client.length != 0) {
                        const managing = response.data.managing_partner_client;
                        this.client_managing_partner_saved.push({
                            document_formatted: managing.document_formatted,
                            name: managing.name,
                            email: managing.email,
                            phone_formatted: managing.phone_formatted,
                        });
                    }

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                });
        },

        getCorporateStructureClient() {
            this.isLoading = true;
            api.get('/client-user/' + this.client.id + '/corporateStructure')
                .then((response) => {
                    this.isLoading = false;
                    this.client_corporate_structure_saved = response.data.corporate_structure_client;

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
        },
    }
}
</script>

<style>
.pointer {
    cursor: pointer;
}
</style>